export interface RevenueReconciliationReportEntity {

    reportTypeList: string[],
    printer: string,
    currency?: string | null,
    cashierId?: string | null,
    subType?: string | null,
    cutOffDateFrom?: Date | null,
    cutOffDateTo?: Date | null,
    cutOffDate2ndFrom?: Date | null,
    cutOffDate2ndTo?: Date | null,
    docDate?: Date | null,
    opsDateFrom?: Date | null,
    opsDateTo?: Date | null,
    cutOffTimeFromHour?: number | null,
    cutOffTimeFromMin?: number | null,
    cutOffTimeToHour?: number | null,
    cutOffTimeToMin?: number | null,
    cutOffTime2ndFromHour?: number | null,
    cutOffTime2ndFromMin?: number | null,
    cutOffTime2ndToHour?: number | null,
    cutOffTime2ndToMin?: number | null,
    opsTimeFromHour?: number | null,
    opsTimeFromMin?: number | null,
    opsTimeToHour?: number | null,
    opsTimeToMin?: number | null,
    docDateTimeHour?: number | null,
    docDateTimeMin?: number | null,

    [key: string]: string | boolean | Date | number | null | Object | undefined
}

export const EMPTY_REVENUE_RECONCILIATION_REPORT_ENTITY: RevenueReconciliationReportEntity = {
    reportTypeList: [],
    printer: "",
    currency: "",
    cutOffDateFrom: null,
    cutOffDateTo: null,
    cutOffDate2ndFrom: null,
    cutOffDate2ndTo: null,
    docDate: null,
    cashierId: null,
    opsDateFrom: null,
    opsDateTo: null,
    subType: null,
    cutOffTimeFromHour: null,
    cutOffTimeFromMin: null,
    cutOffTimeToHour: null,
    cutOffTimeToMin: null,
    cutOffTime2ndFromHour: null,
    cutOffTime2ndFromMin: null,
    cutOffTime2ndToHour: null,
    cutOffTime2ndToMin: null,
    opsTimeFromHour: null,
    opsTimeFromMin: null,
    opsTimeToHour: null,
    opsTimeToMin: null,
    docDateTimeHour: null,
    docDateTimeMin: null,
}
